import { RunTaskEntryType } from '../constants';
export function getAllDetailsPayload(_ref) {
  var _widgetData$automatio;
  let {
    widgetData,
    invocationId,
    entries
  } = _ref;
  const payload = {};
  if (widgetData.metaSiteId) {
    payload.metaSiteId = widgetData.metaSiteId;
  }
  if (invocationId) {
    payload.invocationId = invocationId;
  }
  if ((_widgetData$automatio = widgetData.automation) != null && _widgetData$automatio.id) {
    payload.automationId = widgetData.automation.id;
  }
  if (widgetData.instructions) {
    payload.instructions = widgetData.instructions;
  }
  if (entries.length > 0) {
    payload.runtimeLog = entries.map(entry => {
      const entryData = {
        type: entry.type,
        status: entry.status,
        date: entry.date.toISOString(),
        title: entry.title
      };
      if (entry.type === RunTaskEntryType.ToolCall && entry.message) {
        entryData.message = entry.message;
      } else if (entry.type === RunTaskEntryType.End && entry.message) {
        entryData.message = entry.message;
      }
      if (entry.requestPayload) {
        entryData.request = entry.requestPayload;
      }
      if (entry.resultPayload) {
        entryData.result = entry.resultPayload;
      }
      return entryData;
    });
  }
  return payload;
}
//# sourceMappingURL=getAllDetailsPayload.js.map